import { useCoreEvents, eventNames } from '@carvana/core-events';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useContext, useState } from 'react';
import {
  useSavedSearches,
  useSavedSearchesIsLoaded
} from '~/context/common/SavedSearchesContext';
import { useIsLoggedIn } from '~/context/common/UserContext';
import StaticContext from '~/context/srp/StaticContext';
import useLogInAndManageSavedSearches from '~/hooks/srp/useLogInAndManageSavedSearches';

export default function useShowManageSavedSearchesOnLoad() {
  const { openManageSavedSearchesModal } = useContext(StaticContext);
  const isLoggedIn = useIsLoggedIn();
  const logInAndManageSavedSearches = useLogInAndManageSavedSearches();
  const isSavedSearchesLoaded = useSavedSearchesIsLoaded();
  const savedSearches = useSavedSearches();
  const [isAccountModalModuleLoaded, setIsAccountModalModuleLoaded] =
    useState(false);
  const [isFavoritesModuleLoaded, setIsFavoritesModuleLoaded] = useState(false);

  useCoreEvents(eventNames.accountModal.ready, () => {
    setIsAccountModalModuleLoaded(true);
  });

  useCoreEvents(eventNames.favorites.mfe.ready, () => {
    setIsFavoritesModuleLoaded(true);
  });

  const shouldTryToShow =
    (isLoggedIn || isAccountModalModuleLoaded) &&
    isFavoritesModuleLoaded &&
    isSavedSearchesLoaded &&
    openManageSavedSearchesModal;
  const mayShow = savedSearches.length > 0 || !isLoggedIn;

  useEffectOnce(
    () => {
      if (mayShow) logInAndManageSavedSearches();
    },
    [logInAndManageSavedSearches, mayShow],
    shouldTryToShow
  );
}
